import { createApp } from "vue";
import App from "./App.vue";
import { Actions } from "@/store/enums/StoreEnums";

import router from "@/router/clean";
import store from "./store";
import ApiService from "@/core/services/ApiService";
import BusProxyService from "@/core/services/BusProxyService";
import { redirectLegacyHashRouteToHistory } from "@/core/helpers/maxiVehicleLink";
// i18n + inline-svg: lazy en Layout admin (PSI round 4; Home no los usa)
// vee-validate: lazy en AuthLayout / Layout / forms (PSI round 3)

// Bookmarks/# antiguos → path history; Maxi /car?mpId= ya es nativo con createWebHistory.
if (redirectLegacyHashRouteToHistory()) {
  // location.replace ya se disparó; evitar montar la app en la URL hash.
} else {
  bootstrapApp();
}

function bootstrapApp() {
  const app = createApp(App);

  app.mixin({
    methods: {
      checkPermissions: function (user, module, permission) {
        store
          .dispatch(Actions.CHECK_PERMISSIONS, {
            uuid: user,
            modulo: module,
            permiso: permission,
          })
          .then((response) => {
            return response;
          })
          .catch(() => {
            return false;
          });
      },
    },
  });

  app.directive("resize", {
    mounted(el, binding) {
      // Medir en el siguiente frame: evita force-reflow en el mismo tick del LCP.
      const onResizeCallback = binding.value;
      const resizeHandler = () => {
        requestAnimationFrame(() => {
          const width = el.getBoundingClientRect().width;
          const height = el.getBoundingClientRect().height;
          onResizeCallback({ width, height });
        });
      };
      window.addEventListener("resize", resizeHandler);
      el._onResize = resizeHandler;
    },
    beforeUnmount(el) {
      window.removeEventListener("resize", el._onResize);
    },
  });

  app.use(store);
  app.use(router);
  // DropZone / Datepicker / prism / bootstrap / i18n: lazy en Layout admin (PSI)
  ApiService.init(app);

  if (process.env.VUE_APP_ENABLE_BUS_PROXY === "true") {
    console.log("[App] Iniciando servicio de proxy del BUS");
    BusProxyService.startPolling();
  }
  // Analytics: solo GTM diferido en public/index.html (dataLayer / page tracking).
  app.mount("#app");
}
